import { render } from "./TemperatureResultTable.vue?vue&type=template&id=b9e17dea&ts=true"
import script from "./TemperatureResultTable.vue?vue&type=script&lang=ts"
export * from "./TemperatureResultTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__